module.exports = __webpack_public_path__ + "static/img/software6.5335c76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software6.jpg
// module id = wUH8
// module chunks = 2